import type { ReactNode } from "react";
import { Box, Container, Stack, Typography } from "@mui/material";
import athrivIcon from "@/assets/athriv-icon.png";

export default function LegalPageLayout({ title, updatedAt, children }: { title: string; updatedAt: string; children: ReactNode }) {
  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
      <Container maxWidth="md" sx={{ py: { xs: 4, sm: 8 } }}>
        <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 4 }}>
          <Box component="a" href="/" sx={{ display: "flex", alignItems: "center", gap: 1.5, textDecoration: "none", color: "inherit" }}>
            <Box component="img" src={athrivIcon} alt="Athriv Technologies" sx={{ width: 28, height: 28, objectFit: "contain" }} />
            <Typography variant="h6" fontWeight={700}>Athriv Technologies</Typography>
          </Box>
        </Stack>

        <Typography variant="h4" fontWeight={800} gutterBottom>{title}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>Last updated: {updatedAt}</Typography>

        <Stack spacing={3} sx={{ "& h2": { fontSize: "1.15rem", fontWeight: 700, mt: 2 }, "& p, & li": { color: "text.secondary", lineHeight: 1.7 } }}>
          {children}
        </Stack>
      </Container>
    </Box>
  );
}
